import { render } from "./ClientesRegistro.vue?vue&type=template&id=e17a0e8a"
import script from "./ClientesRegistro.vue?vue&type=script&lang=js"
export * from "./ClientesRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__